(function () {
  'use strict';

  var drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  var form = drawer.querySelector('#CartDrawerForm');
  var productsContainer = drawer.querySelector('[data-products]');
  var discountsContainer = drawer.querySelector('[data-discounts]');
  var subtotalNode = drawer.querySelector('[data-subtotal]');
  var rail = drawer.querySelector('[data-sidecart-rail]');
  var recommendations = drawer.querySelector('[data-sidecart-recommendations]');
  var errorNode = drawer.querySelector('[data-sidecart-error]');
  var moneyFormat = window.theme && theme.settings ? theme.settings.moneyFormat : '${{amount}}';
  var threshold = Number(drawer.dataset.freeShippingThreshold || 12500);
  var recommendationProductsPromise = null;
  var latestCart = null;
  var syncGeneration = 0;
  var mutationInFlight = false;
  var errorTimer = null;
  var syncTimer = null;

  function formatMoney(cents) {
    if (window.theme && theme.Currency) return theme.Currency.formatMoney(cents, moneyFormat);
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function checkedJson(response, fallbackMessage) {
    return response.json().catch(function () { return {}; }).then(function (data) {
      if (!response.ok) {
        throw new Error(data.description || data.message || fallbackMessage);
      }
      return data;
    });
  }

  function checkedText(response, fallbackMessage) {
    if (!response.ok) throw new Error(fallbackMessage);
    return response.text();
  }

  function fetchCart() {
    return fetch('/cart.js?t=' + Date.now(), { credentials: 'same-origin' })
      .then(function (response) { return checkedJson(response, 'Unable to load your bag.'); });
  }

  function fetchCartMarkup() {
    return fetch('/cart?view=ajax&t=' + Date.now(), { credentials: 'same-origin' })
      .then(function (response) { return checkedText(response, 'Unable to refresh your bag.'); });
  }

  function changeCartItem(key, quantity) {
    return fetch('/cart/change.js?t=' + Date.now(), {
      method: 'POST',
      body: JSON.stringify({ id: key, quantity: quantity }),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (response) { return checkedJson(response, 'Unable to update your bag.'); });
  }

  function updateProgress(cart) {
    var message = drawer.querySelector('[data-sidecart-shipping-message]');
    var bar = drawer.querySelector('[data-sidecart-progress]');
    var progress = drawer.querySelector('.hot-sidecart__progress');
    if (!message || !bar || !progress) return;

    var subtotal = Number(cart.total_price || 0);
    var percent = Math.min(100, Math.max(0, subtotal / threshold * 100));
    var remaining = Math.max(0, threshold - subtotal);
    message.textContent = remaining === 0
      ? 'Free standard shipping unlocked! *exclusions apply'
      : 'You\u2019re ' + formatMoney(remaining) + ' away from free shipping';
    bar.style.width = percent + '%';
    progress.setAttribute('aria-valuenow', Math.min(threshold, subtotal));
  }

  function updateCartBubble(cart) {
    var bubble = document.getElementById('CartBubble');
    var count = document.querySelector('.cart-link__bubble-num');
    if (count) count.textContent = cart.item_count;
    if (bubble) bubble.classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
  }

  function escapeHtml(value) {
    var node = document.createElement('div');
    node.textContent = value || '';
    return node.innerHTML;
  }

  function enhanceCartMarkup() {
    drawer.querySelectorAll('.cart__item').forEach(function (item) {
      var removeLink = item.querySelector('.cart__remove a');
      var title = item.querySelector('.cart__item-name');
      if (removeLink && title) {
        removeLink.setAttribute('aria-label', 'Remove ' + title.textContent.trim() + ' from cart');
      }
    });
  }

  function renderCartMarkup(html, cart) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var items = doc.querySelector('.cart__items');
    var discounts = doc.querySelector('.cart__discounts');
    if (!items) throw new Error('Unable to refresh your bag.');

    productsContainer.innerHTML = '';
    productsContainer.appendChild(document.importNode(items, true));

    if (discountsContainer) {
      discountsContainer.innerHTML = '';
      if (discounts) discountsContainer.appendChild(document.importNode(discounts, true));
    }

    drawer.classList.toggle('is-empty', cart.item_count === 0);
    if (subtotalNode) subtotalNode.innerHTML = formatMoney(cart.total_price);
    updateCartBubble(cart);
    enhanceCartMarkup();
  }

  function productImage(product) {
    var image = product.images && product.images[0] ? product.images[0].src : product.featured_image;
    if (!image) return '';
    return image.replace(/(\.[a-zA-Z]{3,4})(\?.*)?$/, '_360x$1$2');
  }

  function productIsAvailable(product) {
    return (product.variants || []).some(function (variant) { return variant.available; });
  }

  function productPrice(product) {
    var prices = (product.variants || []).map(function (variant) {
      return Math.round(parseFloat(variant.price || 0) * 100);
    }).filter(function (price) { return price > 0; });
    return prices.length ? Math.min.apply(Math, prices) : 0;
  }

  function productPriceVaries(product) {
    var prices = (product.variants || []).map(function (variant) { return variant.price; });
    return prices.some(function (price) { return price !== prices[0]; });
  }

  function renderRecommendations(products, cart) {
    var cartProductIds = {};
    cart.items.forEach(function (item) { cartProductIds[item.product_id] = true; });

    var cards = products.filter(function (product) {
      return productIsAvailable(product) && !cartProductIds[product.id] && productImage(product);
    }).slice(0, 8).map(function (product) {
      var price = productPriceVaries(product)
        ? 'From ' + formatMoney(productPrice(product))
        : formatMoney(productPrice(product));
      var productUrl = '/products/' + encodeURIComponent(product.handle);
      return '<article class="hot-sidecart__recommendation">' +
        '<a class="hot-sidecart__recommendation-image" href="' + productUrl + '">' +
          '<img src="' + productImage(product) + '" alt="' + escapeHtml(product.title) + '" loading="lazy" width="232" height="290">' +
        '</a>' +
        '<a class="hot-sidecart__recommendation-title" href="' + productUrl + '">' + escapeHtml(product.title) + '</a>' +
        '<div class="hot-sidecart__recommendation-price">' + price + '</div>' +
      '</article>';
    }).join('');

    rail.innerHTML = cards;
    recommendations.hidden = !cards;
  }

  function getRecommendationProducts() {
    if (recommendationProductsPromise) return recommendationProductsPromise;

    recommendationProductsPromise = fetch('/collections/shop-all/products.json?limit=24', {
      credentials: 'same-origin'
    }).then(function (response) {
      return checkedJson(response, 'Unable to load recommendations.');
    }).then(function (data) {
      return data.products || [];
    }).catch(function (error) {
      recommendationProductsPromise = null;
      throw error;
    });

    return recommendationProductsPromise;
  }

  function loadRecommendations(cart, generation) {
    if (!cart.items.length) {
      rail.innerHTML = '';
      recommendations.hidden = true;
      return Promise.resolve();
    }

    return getRecommendationProducts().then(function (products) {
      if (generation !== syncGeneration) return;
      renderRecommendations(products, cart);
    }).catch(function () {
      if (generation === syncGeneration) recommendations.hidden = true;
    });
  }

  function applyCartState(cart, generation) {
    latestCart = cart;
    updateProgress(cart);
    updateCartBubble(cart);
    loadRecommendations(cart, generation);
  }

  function showError(message) {
    if (!errorNode) return;
    window.clearTimeout(errorTimer);
    errorNode.textContent = message || 'We couldn\u2019t update your bag. Please try again.';
    errorNode.hidden = false;
    errorTimer = window.setTimeout(function () { errorNode.hidden = true; }, 5000);
  }

  function clearError() {
    if (!errorNode) return;
    window.clearTimeout(errorTimer);
    errorNode.hidden = true;
  }

  function setBusy(isBusy) {
    mutationInFlight = isBusy;
    drawer.classList.toggle('hot-sidecart--updating', isBusy);
    if (productsContainer) productsContainer.setAttribute('aria-busy', isBusy ? 'true' : 'false');
  }

  function syncSidecart() {
    if (mutationInFlight) return Promise.resolve();
    var generation = ++syncGeneration;

    return Promise.all([fetchCart(), fetchCartMarkup()]).then(function (results) {
      if (generation !== syncGeneration) return;
      renderCartMarkup(results[1], results[0]);
      applyCartState(results[0], generation);
    }).catch(function (error) {
      if (generation === syncGeneration) showError(error.message);
    });
  }

  function scheduleSync() {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncSidecart, 0);
  }

  function mutateLine(key, quantity) {
    if (!key || mutationInFlight) return;
    clearError();
    setBusy(true);
    var generation = ++syncGeneration;

    changeCartItem(key, quantity).then(function (cart) {
      return fetchCartMarkup().then(function (html) {
        if (generation !== syncGeneration) return;
        renderCartMarkup(html, cart);
        applyCartState(cart, generation);
        setBusy(false);
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cart: cart, hotSidecartHandled: true }
        }));
      });
    }).catch(function () {
      setBusy(false);
      showError('We couldn\u2019t update your bag. Please try again.');
      scheduleSync();
    });
  }

  function cartPermalink(cart) {
    if (!cart || !cart.items || !cart.items.length) return window.location.origin + '/cart';
    var lines = cart.items.map(function (item) {
      return item.variant_id + ':' + item.quantity;
    }).join(',');
    return window.location.origin + '/cart/' + lines;
  }

  drawer.addEventListener('click', function (event) {
    var adjust = event.target.closest('.js-qty__adjust');
    var remove = event.target.closest('.cart__remove a');
    if (!adjust && !remove) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (mutationInFlight) return;

    var item = event.target.closest('.cart__item');
    var input = item && item.querySelector('.js-qty__num');
    if (!item || !input) return;

    var quantity = Number(input.value) || 1;
    if (remove) quantity = 0;
    if (adjust && adjust.classList.contains('js-qty__adjust--plus')) quantity += 1;
    if (adjust && adjust.classList.contains('js-qty__adjust--minus')) {
      quantity = Math.max(Number(input.min || 0), quantity - 1);
    }

    mutateLine(input.dataset.id, quantity);
  }, true);

  drawer.addEventListener('change', function (event) {
    var input = event.target.closest('.js-qty__num');
    if (!input) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (mutationInFlight) return;

    var quantity = Math.max(Number(input.min || 0), Math.floor(Number(input.value) || 1));
    mutateLine(input.dataset.id, quantity);
  }, true);

  drawer.querySelector('[data-sidecart-prev]').addEventListener('click', function () {
    rail.scrollBy({ left: -248, behavior: 'smooth' });
  });

  drawer.querySelector('[data-sidecart-next]').addEventListener('click', function () {
    rail.scrollBy({ left: 248, behavior: 'smooth' });
  });

  drawer.querySelector('[data-sidecart-share]').addEventListener('click', function () {
    var share = function (cart) {
      var url = cartPermalink(cart);
      if (navigator.share) {
        return navigator.share({ title: document.title, url: url }).catch(function () {});
      }
      if (navigator.clipboard) {
        return navigator.clipboard.writeText(url).then(function () {
          var button = drawer.querySelector('[data-sidecart-share]');
          button.firstChild.nodeValue = 'Link copied ';
          window.setTimeout(function () { button.firstChild.nodeValue = 'Share '; }, 1600);
        });
      }
    };

    if (latestCart) {
      share(latestCart);
    } else {
      fetchCart().then(share).catch(function () { showError('Unable to share your bag right now.'); });
    }
  });

  document.addEventListener('ajaxProduct:added', scheduleSync);
  document.addEventListener('cart:updated', function (event) {
    if (event.detail && event.detail.hotSidecartHandled) return;
    if (event.detail && event.detail.cart) {
      var generation = ++syncGeneration;
      applyCartState(event.detail.cart, generation);
    }
    scheduleSync();
  });
  document.addEventListener('cart:open', scheduleSync);
  document.addEventListener('drawerOpen.CartDrawer', scheduleSync);
  document.addEventListener('DOMContentLoaded', scheduleSync);

  if (productsContainer) {
    new MutationObserver(enhanceCartMarkup).observe(productsContainer, { childList: true, subtree: true });
    enhanceCartMarkup();
  }

})();
